import { useCallback, useEffect, useState } from 'react';
import { getPartnerInversion } from 'modules/partners/api/getPartnerInversion';

export const usePartnerInversion = (partnerId: string, societyId: string) => {
  const [inversion, setInversion] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchPartnerInversion = useCallback(async () => {
    if (!partnerId || !societyId) return;

    try {
      setIsLoading(true);
      setIsError(false);

      const currentInversion = (await getPartnerInversion({
        partnerId,
        societyId,
      })) as number;

      setInversion(currentInversion);
    } catch (error) {
      console.error('Failed to fetch partner inversion:', error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [partnerId, societyId]);

  useEffect(() => {
    fetchPartnerInversion();
  }, [fetchPartnerInversion]);

  return {
    inversion,
    isLoading,
    isError,
    refetch: fetchPartnerInversion,
  };
};
